import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 308  -  插入CG鉴赏
 */

export default class EventCGAdd extends EventBase {
  /**
   * 插入CG鉴赏的构造函数
   */
  public constructor() {
    super()
    this.Parameter = ['0', '']
  }

  // #region 事件内关键属性参数
  /**
   * 索引
   */
  get Index() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set Index(value) {
    this.Parameter![0] = value.toString()
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[1]
  }
  set Description(value) {
    this.Parameter![1] = value?.toString() ?? ''
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.CGAdd

  /**
   * 获得该事件在事件列表的描述信息（对于显示图片而言，是第9项）
   */
  /// <returns>事件描述信息</returns>
}
